module.exports = `${require.publicPath}icon05.5f24f7dd.png`;